import store from '../store'
import Api from './Api'

class Auth {
	constructor() {
		this.host = process.env.VUE_APP_API_ORIGIN;
		this.api = new Api()
	}

	async login(email, password) {
		await this.api.post('staffs/login', { "email": email, "password": password })
			.then((res) => {
				store.commit('basic', {
					key: 'auth',
					value: res.data,
				})
			})
			.catch((error) => {
				throw new Error(error.response.data.message);
			}
		);
	}

	logout() {
		store.commit('basic', {
			key: 'auth',
			value: null,
		});
		store.commit('basic', {
			key: 'isInAppBase',
			value: false,
		});
	}

	get user() {
		return store.state.auth;
	}

	get token() {
		return store.state.auth.token;
	}

	get isLoggedIn() {
		return store.state.auth !== null;
	}
}

export default Auth
